import { normalizeIndianMobile } from "./indianIdInput";

export const MANAGER_SIGNUP_TOTAL_STEPS = 5;

export const INIT_MANAGER_SIGNUP = {
  city: "Bengaluru",
  state: "Karnataka",
  pinCode: "",
  serviceAreas: [],
  servicesOffered: [],
  managerType: "INDEPENDENT_PRACTITIONER",
  qualificationSummary: "",
  experienceYears: "5",
  employmentStatus: "",
  termsAccepted: false,
};

export function normalizeCmPin(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 6);
}

export function validateManagerSignupStep(step, createValues, managerForm) {
  if (step === 1) {
    if (!String(createValues.firstName || "").trim()) return "Enter your first name.";
    if (!normalizeIndianMobile(createValues.mobile)) return "Enter a valid 10-digit mobile number.";
  }
  if (step === 2) {
    if (!managerForm.managerType) return "Select your care manager type.";
    if (managerForm.experienceYears === "") return "Select years of experience.";
    if (String(managerForm.qualificationSummary || "").trim().length < 8) {
      return "Enter your professional qualification.";
    }
    if (String(managerForm.employmentStatus || "").trim().length < 8) {
      return "Enter your current employment status.";
    }
  }
  if (step === 3) {
    if (!managerForm.city) return "Select your primary city.";
    if (normalizeCmPin(managerForm.pinCode).length !== 6) return "Enter a valid 6-digit PIN code.";
    if (!managerForm.serviceAreas?.length) return "Select at least one area served in your city.";
  }
  if (step === 4) {
    if (!managerForm.servicesOffered?.length) return "Select at least one clinical service specialty.";
  }
  if (step === 5) {
    if (!managerForm.termsAccepted) return "You must agree to the Terms & Conditions.";
  }
  return "";
}
